import { useStoreState } from "pullstate";
import Store from "../../utils/Store";
import Modal from "../common/Modal";
import Support from "./index";
import { useTranslation } from "react-i18next";
import AwesomeIcon from "../AwesomeIcon";
import { faHeadset, faXmark } from "@fortawesome/pro-regular-svg-icons";

const SupportModal = () => {
  const { t } = useTranslation();
  const isVisible = useStoreState(Store, (s) => s.isSupportOpen);

  const onClose = () => {
    Store.update((s) => {
      s.isSupportOpen = false;
    });
  };

  return (
    <Modal
      show={isVisible}
      onClose={onClose}
      closeOnClickAway
      className="flex flex-col w-full max-w-[721px] sm:w-10/12 h-4/5 overflow-hidden bg-[#d9dbdd] dark:bg-[#0c1723] rounded-[16px] border-0 [&>:first-child]:!rounded-t-[16px] [&>:first-child]:!border-b [&>:first-child]:!border-[#d9dbdd] [&>:first-child]:dark:!border-gray-600 [&>:first-child]:!bg-[#f6f7f7] [&>:first-child]:dark:!bg-gray-800 [&>:first-child]:!h-[56px] [&>:first-child]:!min-h-[56px] [&>:first-child]:!py-0 [&>:first-child]:!px-4 [&>:first-child]:items-center"
      title={
        <div className="flex items-center gap-3">
          <div className="flex shrink-0 w-7 h-7 items-center justify-center text-[#0c1723] dark:text-gray-100">
            <AwesomeIcon name={faHeadset} className="w-7 h-7" />
          </div>
          <p className="font-sans font-medium text-lg tracking-[0] text-[#0c1723] dark:text-gray-100 whitespace-nowrap">
            {t("support.title", { defaultValue: "Support" })}
          </p>
        </div>
      }
      titleClassName="!bg-transparent !border-0 !p-0 !h-auto text-left !text-lg"
      closeButton={
        <button
          type="button"
          onClick={onClose}
          className="shrink-0 size-7 flex items-center justify-center rounded bg-[#d9dbdd] dark:bg-gray-900 hover:bg-[#c5c8cb] dark:hover:bg-gray-700 text-[#0c1723] dark:text-gray-100 transition-colors"
          aria-label={t("common.close", { defaultValue: "Close" })}
        >
          <AwesomeIcon name={faXmark} size="lg" className="w-5 h-5" />
        </button>
      }
    >
      <div className="flex flex-col flex-1 min-h-0 overflow-auto bg-[#d9dbdd] dark:bg-[#0c1723] rounded-b-[16px]">
        <Support pageName="support" isModal modalOpen={isVisible} />
      </div>
    </Modal>
  );
};

export default SupportModal;
